import { render, staticRenderFns } from "./MyCheckbox.vue?vue&type=template&id=20c1de61&scoped=true&"
import script from "./MyCheckbox.vue?vue&type=script&lang=js&"
export * from "./MyCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1de61",
  null
  
)

export default component.exports